import React from 'react';
import { SxStyle } from '../../../types';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { drawerWidth } from '../../../constants';

const styles: SxStyle = {
  container: {
    marginTop: '60px',
    backgroundColor: '#ffffff',
    paddingLeft: '16px',
    paddingRight: '16px',
    borderBottomStyle: 'solid',
    borderBottomWidth: '1px',
    borderBottomColor: 'rgb(0, 0, 0, 12%)',
  },
  containerInContent: {
    marginTop: '10px',
  },
  tab: (theme) => ({
    [theme.breakpoints.down('md')]: {
      width: '180px',
    },
    width: '280px',
  }),
};

export interface SceneTabsProps {
  tabs: string[];
  selectedTab: number;
  onSelectedTab: (selectedTab: number) => void;
  inContent?: boolean;
}

const SceneTabs = ({ tabs, selectedTab, onSelectedTab, inContent }: SceneTabsProps) => {
  const combinedStyles: SxStyle = {
    content: (theme) => ({
      [theme.breakpoints.up('sm')]: {
        marginLeft: `${drawerWidth}px`,
      },
      ...styles.container,
      ...(inContent ? styles.containerInContent : {}),
    }),
  } as const;

  return (
    <Box sx={combinedStyles.content}>
      <Tabs
        value={selectedTab}
        indicatorColor="primary"
        textColor="primary"
        onChange={(event, value) => onSelectedTab(value)}
      >
        {tabs.map((tab) => (
          <Tab key={tab} label={tab} />
        ))}
      </Tabs>
    </Box>
  );
};

export default SceneTabs;
